module.exports = __webpack_public_path__ + "img/landing-frame-02.0ec424d5.png";